
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

export class GenMemberRole {
    static readonly MANAGER: GenMemberRole = new GenMemberRole('MANAGER');
    static readonly MEMBER: GenMemberRole = new GenMemberRole('MEMBER');

    public readonly name: string;

    private constructor(name: string) {
        this.name = name;
    }

    static forName(name: string) {
        if (name === 'MANAGER') return GenMemberRole.MANAGER;
        if (name === 'MEMBER') return GenMemberRole.MEMBER;
        throw new Error('Unexpected value for GenMemberRole:' + name);
    }

    static values(): GenMemberRole[] {
        return [
            GenMemberRole.MANAGER,
            GenMemberRole.MEMBER,
        ];
    }

    toJSON(): string {
        return this.name;
    }

    toString(): string {
        return this.name;
    }
}

